module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_41.46ba23c7.jpg";